import getPowerLabel from 'utils/power/getPowerLabel';

interface IOptions {
  fixed?: number;
  ellipsis?: boolean;
  unit?: string;
  fixedZero?: boolean;
}

const getComputingSpeedUnit = (value: number, power: number, options?: IOptions) => {
  const { fixed = 2, ellipsis, unit = 'H/s', fixedZero } = options || {};

  const powerLabel = getPowerLabel(power);

  let valueLabel: string | number = value || 0;

  if ((fixed && value) || (fixed && fixedZero && !value)) {
    valueLabel = value.toFixed(fixed);
  }

  const ellipsisLabel = ellipsis ? '...' : '';

  return `${valueLabel}${ellipsisLabel} ${powerLabel}${unit}`;
};

export default getComputingSpeedUnit;
